import { createHashRouter } from "react-router-dom";
import App from "App";
import Activities from "pages/activities/activities";
import Downloads from "pages/downloads";
import Library from "pages/library/library";
import Applications from "pages/applications/applications";
import Course from "pages/course/course";
import Disconnected from "pages/disconnected/disconnected";
import Legals from "pages/legals/legals";

export const router = createHashRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { 
        path: "", 
        element: <Activities />, 
      },
      { 
        path: "course", 
        element: <Course />, 
      },
      { 
        path: "done/course", 
        element: <Course />, 
      },
      { 
        path: "library/course", 
        element: <Course />, 
      },
      { 
        path: "done", 
        element: <Activities /> ,
      },
      { 
        path: "offline", 
        element: <Downloads /> 
      },
      { 
        path: "library", 
        element: <Library />,
      },
      { 
        path: "applications", 
        element: <Applications />,
      }
    ],
  },
  {
    path: "disconnected",
    element: <Disconnected />,
  },
  {
    path: "legals",
    element: <Legals />,
  }
]);